import { Container, Grid } from "@mui/material";
import ButtonNav from "../components/General/ButtonNav";
import { useAuth } from "../context/AuthContext";

import ManageAccountsRoundedIcon from "@mui/icons-material/ManageAccountsRounded";
import PolicyRoundedIcon from "@mui/icons-material/PolicyRounded";

export default function Security() {
  const { hasPermission } = useAuth();

  return (
    <Container maxWidth="lg" sx={{ mt: 4 }}>
      <Grid container spacing={2} sx={{ mt: 2 }}>
        {hasPermission("roles") && (
          <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
            <ButtonNav
              title="Roles"
              subtitle="Gestión de permisos"
              icon={<ManageAccountsRoundedIcon />}
              color="#2563eb"
              to="/roles"
            />
          </Grid>
        )}
        {hasPermission("ver auditorias") && (
          <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
            <ButtonNav
              title="Auditoría"
              subtitle="Registro de acciones del sistema"
              icon={<PolicyRoundedIcon />}
              color="#7c3aed"
              to="/security/audit"
            />
          </Grid>
        )}
      </Grid>
    </Container>
  );
}
